<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CompanyService from "@/services/company";
import DatePicker from "vue2-datepicker";

export default {
  page: {
    title: "Horário de Funcionamento",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  data() {
    return {
      title: "Horário de Funcionamento",
      working_hours: {
        monday: { open_time: '', close_time: '', closed: false },
        tuesday: { open_time: '', close_time: '', closed: false },
        wednesday: { open_time: '', close_time: '', closed: false },
        thursday: { open_time: '', close_time: '', closed: false },
        friday: { open_time: '', close_time: '', closed: false },
        saturday: { open_time: '', close_time: '', closed: false },
        sunday: { open_time: '', close_time: '', closed: false },
      },
      message: {
        title: '',
        msg: '',
      },
      loading: false
    };
  },
  methods: {
    load(showLoading = true) {
      let loader;
      if (showLoading) {
        loader = this.$loading.show();
      }

      CompanyService.getCompanyData().then(res => {
        this.working_hours = res.data.working_hours;

        if (loader) {
          loader.hide();
        }
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao carregar os dados');

        if (loader) {
          loader.hide();
        }
      })
    },
    save() {
      let loader = this.$loading.show();

      const data = {
        working_hours: this.working_hours,
      }

      CompanyService.updateCompanyData(data).then(() => {
        this.$toast.open('Configurações atualizadas com sucesso');
        this.load(false);

        loader.hide();
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao atualizar os dados');
        loader.hide();
      })
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Horário de Funcionamento</h4>
            <p class="card-title-desc">Configure o horário de abertura da sua loja para definir o período de recebimento dos pedidos</p>

            <form>
              <div class="row mb-0">
                <div class="col-3">
                </div>

                <div class="col-3">
                  <div class="form-group mb-0">
                    <label for="bank">Abre às</label>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group mb-0">
                    <label for="agency">Fecha às</label>
                  </div>
                </div>
              </div>

              <!-- SEGUNDA -->
              <div class="row">
                <div class="col-2 align-self-end">
                  <div class="form-group">
                    <label for="bank">Segunda-feira</label>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.monday.open_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.monday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.monday.close_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.monday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group align-self-end mt-2">
                    <div class="custom-control custom-checkbox align-self-end">
                      <input type="checkbox" class="custom-control-input" id="mondayClosed" v-model="working_hours.monday.closed" />
                      <label class="custom-control-label" for="mondayClosed">Fechado</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- TERCA -->
              <div class="row">
                <div class="col-2 align-self-end">
                  <div class="form-group">
                    <label for="bank">Terça-feira</label>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.tuesday.open_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.tuesday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.tuesday.close_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.tuesday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group align-self-end mt-2">
                    <div class="custom-control custom-checkbox align-self-end">
                      <input type="checkbox" class="custom-control-input" id="tuesdayClosed" v-model="working_hours.tuesday.closed" />
                      <label class="custom-control-label" for="tuesdayClosed">Fechado</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- QUARTA -->
              <div class="row">
                <div class="col-2 align-self-end">
                  <div class="form-group">
                    <label for="bank">Quarta-feira</label>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.wednesday.open_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.wednesday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.wednesday.close_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.wednesday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group align-self-end mt-2">
                    <div class="custom-control custom-checkbox align-self-end">
                      <input type="checkbox" class="custom-control-input" id="wednesdayClosed" v-model="working_hours.wednesday.closed" />
                      <label class="custom-control-label" for="wednesdayClosed">Fechado</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- QUINTA -->
              <div class="row">
                <div class="col-2 align-self-end">
                  <div class="form-group">
                    <label for="bank">Quinta-feira</label>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.thursday.open_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.thursday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.thursday.close_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.thursday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group align-self-end mt-2">
                    <div class="custom-control custom-checkbox align-self-end">
                      <input type="checkbox" class="custom-control-input" id="thursdayClosed" v-model="working_hours.thursday.closed" />
                      <label class="custom-control-label" for="thursdayClosed">Fechado</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SEXTA -->
              <div class="row">
                <div class="col-2 align-self-end">
                  <div class="form-group">
                    <label for="bank">Sexta-feira</label>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.friday.open_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.friday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.friday.close_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.friday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group align-self-end mt-2">
                    <div class="custom-control custom-checkbox align-self-end">
                      <input type="checkbox" class="custom-control-input" id="fridayClosed" v-model="working_hours.friday.closed" />
                      <label class="custom-control-label" for="fridayClosed">Fechado</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- SABADO -->
              <div class="row">
                <div class="col-2 align-self-end">
                  <div class="form-group">
                    <label for="bank">Sábado</label>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.saturday.open_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.saturday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.saturday.close_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.saturday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group align-self-end mt-2">
                    <div class="custom-control custom-checkbox align-self-end">
                      <input type="checkbox" class="custom-control-input" id="saturdayClosed" v-model="working_hours.saturday.closed" />
                      <label class="custom-control-label" for="saturdayClosed">Fechado</label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- DOMINGO -->
              <div class="row">
                <div class="col-2 align-self-end">
                  <div class="form-group">
                    <label for="bank">Domingo e Feriado</label>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.sunday.open_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.sunday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group">
                    <date-picker
                      v-model="working_hours.sunday.close_time"
                      format="HH:mm"
                      value-type="format"
                      type="time"
                      :minute-step="5"
                      :disabled="working_hours.sunday.closed"
                    ></date-picker>
                  </div>
                </div>

                <div class="col-3">
                  <div class="form-group align-self-end mt-2">
                    <div class="custom-control custom-checkbox align-self-end">
                      <input type="checkbox" class="custom-control-input" id="sundayClosed" v-model="working_hours.sunday.closed" />
                      <label class="custom-control-label" for="sundayClosed">Fechado</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12">
                  <div class="text-sm-right">
                    <button type="button" class="btn btn-success btn-rounded" @click="save">Salvar Horário de Funcionamento</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
  input[type="file"] {
    display: none;
  }

  .mx-input:disabled {
    background-color: #eee !important;
  }
</style>